import * as React from 'react';
import styles from './header.module.css';
import { ApplicationState, ConnectedReduxProps } from '../../store';
import { DetailsSharedActionPage, SharedActionPage } from '../../store/details/shared/model';
import { InsuredRisk, PolicySubTypeTCEnum } from '../../store/details/policy/types';
import { changePage, resetSelectedPage } from '../../store/details/shared/actions';
import { clearCases, fetchCases, resetCasesState, archiveCaseClose, archiveCaseOpen, dearchiveCase, assignUserOpen, assignUserClose, assignUser, changeAssignedUserId, setInProgressState } from '../../store/case/actions';
import { BelfiusText } from '../custom';
import { BelfiusTooltip } from '../custom/belfius-tooltip';
import { CaseSearch, CaseSearchParam, CaseResponse, UserAccountResponse } from '../../store/case/model';
import { DetailsInsuredPersonState } from '../../store/details/insured-person/types';
import { Dispatch } from 'redux';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import { Link, Params } from 'react-router-dom';
import { Role } from '../../store/shared/model';
import { connect } from 'react-redux';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import { logout } from '../../store/login/actions';
import { resetDetailsCaseState } from '../../store/details/case/actions';
import { resetDetailsExpertiseAttachmentState } from '../../store/details/expertise-attachment/actions';
import { resetDetailsHonoraryNoteState } from '../../store/details/honorary-note/actions';
import { resetDetailsImagesState } from '../../store/details/images/actions';
import { resetDetailsInsuredPersonState } from '../../store/details/insured-person/actions';
import { resetDetailsOtherAttachmentsState } from '../../store/details/other-attachments/actions';
import { resetDetailsPolicyState } from '../../store/details/policy/actions';
import { resetDetailsRimState } from '../../store/details/rim/actions';
import { resetSvsState } from '../../store/details/svs/actions';
import { archiveCase, showSearchBar } from '../../store/case';
import { ArchiveCaseModal } from './archiveCaseModal';
import { AssignCaseModal } from './assignCaseModal';
import withParams from './withParams'
import { CaseSortColumnType } from '../../../src/store/case/types';
import { SortColumnDirectionType } from '../../../src/store/shared/types';

interface PropsFromState {
  readonly searchBarVisible: boolean;
  readonly currentPage: DetailsSharedActionPage;
  readonly insuredPerson: DetailsInsuredPersonState;
  readonly insuredRisk: InsuredRisk;
  readonly countOfOpened: number;
  readonly countOfArchived: number;
  readonly countOfHasDocForApproval: number;
  readonly countOfHonoraryNoteMissing: number;
  readonly countOfUnassigned: number;
  readonly roles: string[];
  readonly caseSearch: CaseSearch;
  readonly damageIcon: string;
  readonly policySubTypeTC: string;
  readonly hasDocumentsForApproval: number;
  readonly caseBlocked: boolean;
  readonly caseCode: string;
  readonly expertName: string;
  readonly selectedCase: CaseResponse;
  readonly showArchiveModal: boolean;
  readonly showAssignModal: boolean;
  readonly assignableUsers: UserAccountResponse[];
  readonly selectedAssignedUserId: number | '';
  readonly selectedClaimNotificationId: number;
}

interface PropsFromDispatch {
  readonly showSearchBar: typeof showSearchBar;
  readonly resetDetailsState: Function;
  readonly changePage: typeof changePage;
  readonly logout: Function;
  readonly fetchCases: typeof fetchCases;
  readonly clearCases: typeof clearCases;
  readonly archiveCase: typeof archiveCase;
  readonly archiveCaseClose: typeof archiveCaseClose;
  readonly archiveCaseOpen: typeof archiveCaseOpen;
  readonly dearchiveCase: typeof dearchiveCase;
  readonly assignUserOpen: typeof assignUserOpen;
  readonly assignUserClose: typeof assignUserClose;
  readonly assignUser: typeof assignUser;
  readonly changeAssignedUserId: typeof changeAssignedUserId;
  readonly setInProgressState: typeof setInProgressState;
}

// Higher-order component interface
interface WithParamsProps {
  params: Params<string>;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps & WithParamsProps;

class Header extends React.Component<AllProps> {
  private localization: Ii18n;
  private instructionId: number;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
    this.instructionId = Number(this.props.params.instructionId);
  }

  // componentDidMount(): void {
  //   const { instructionId } = this.props.params;
  // }

  private getActionButton() {
    const pathname = window.location.pathname;

    if (pathname === '/') {
      return (
        <div style={{ display: 'inline-flex' }}>
          <div className={styles.button} onClick={() => this.props.showSearchBar()}>
            <BelfiusTooltip title={this.localization.get('home.search.button')}>
              <img alt="" src={require('../../assets/images/search_85x85.png')} />
            </BelfiusTooltip>
          </div>
        </div>
      );
    } else if (pathname.startsWith('/details')) {
      return (
        <div style={{ display: 'inline-flex' }}>
          <div
            className={styles.button}
            onClick={() => { if (!this.props.caseBlocked) {
              window.history.replaceState({}, '', `#${DetailsSharedActionPage.AGENDA.toLowerCase()}`);
              const pageRequest = new SharedActionPage();
              pageRequest.instructionId = this.instructionId;
              pageRequest.previousPage = this.props.currentPage;
              pageRequest.page = DetailsSharedActionPage.AGENDA;
              this.props.changePage(pageRequest);
            }
            }}
          >
            <img alt="" title={this.localization.get('details.agenda.header')} src={require('../../assets/images/agenda_85x85.png')} />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  private getArchiveCaseButton() {
    const pathname = window.location.pathname;

    if (pathname === '/') {
      return;
    } else if (pathname.startsWith('/details') && this.props.roles.includes(Role.ClCa) && !this.props.selectedCase.blocked) {
      return (
        <div style={{ display: 'inline-flex' }}>
          <div className={styles.button}>
         <img alt="" onClick={() => this.props.archiveCaseOpen(this.props.selectedCase)}
            title={this.props.selectedCase && this.props.selectedCase.archived
              ? this.localization.get('home.dearchive')
              : this.localization.get('home.archive')}
            src={this.props.selectedCase.archived
              ? require('../../assets/images/dearchive_85x85.png')
              : require('../../assets/images/archive_85x85.png')} />
            </div>
            <ArchiveCaseModal
              selectedCase={this.props.selectedCase}
              archiveCaseClose={this.props.archiveCaseClose}
              archiveCase={this.props.archiveCase.bind(this)}
              dearchiveCase={this.props.dearchiveCase.bind(this)}
              showArchiveModal={this.props.showArchiveModal}
          ></ArchiveCaseModal>
        </div>
      );
    } else {
      return null;
    }
  }

  private getAssignUserButton() {
    const pathname = window.location.pathname;

    if (pathname === '/') {
      return;
    } else if (pathname.startsWith('/details') && this.props.roles.includes(Role.AsUs) && !this.props.selectedCase.blocked )  {
      return (
        <div style={{ display: 'inline-flex' }}>
          <div className={styles.button}>
         <img alt="" title={this.localization.get('home.assignUser.button')} onClick={() => this.props.assignUserOpen(this.props.selectedCase.claimNotificationId)}
            src={this.props.selectedCase.assignedUserId > 0
              ? require('../../assets/images/assign_selected_85x85.png')
              : require('../../assets/images/assign_notselected_85x85.png')} />
             </div>
             <AssignCaseModal
                selectedCase={this.props.selectedCase}
                showAssignModal={this.props.showAssignModal}
                assignableUsers= {this.props.assignableUsers}
                selectedAssignedUserId={this.props.selectedAssignedUserId}
                selectedClaimNotificationId={this.props.selectedClaimNotificationId}
                assignUserOpen={this.props.assignUserOpen.bind(this)}
                assignUserClose={this.props.assignUserClose}
                assignUser={this.props.assignUser.bind(this)}
                changeAssignedUserId={this.props.changeAssignedUserId.bind(this)}
            ></AssignCaseModal>
        </div>
      );
    } else {
      return null;
    }
  }

  private renderHonoraryNoteTaskLink() {
    if (!this.props.roles.includes(Role.CrInIn)) { return; }
    return (
      <div className={this.props.caseSearch.hasMissingHonoraryNote ? [styles.taskFilterLinkWithMargin, styles.bold].join(' ') : styles.taskFilterLinkWithMargin }>
      <span onClick={() => { this.searchCasesByFilterBar(CaseSearchParam.HasHonoraryNoteMissing); }}>{this.localization.get('header.honoraryNoteTasks')}</span><span>: {this.props.countOfHonoraryNoteMissing}</span></div>);
  }

  private renderDocumentsForApprovalCount() {
    if (!this.props.roles.includes(Role.ApAs)) { return; }
    return (
    <div className={this.props.caseSearch.hasDocumentForApproval ? [styles.taskFilterLinkWithMargin, styles.bold].join(' ') : styles.taskFilterLinkWithMargin }>
      <span onClick={() => {this.searchCasesByFilterBar(CaseSearchParam.HasDocumentForApproval); }}>{this.localization.get('header.assessmentApprovalTasks')}</span>
      <span>: {this.props.countOfHasDocForApproval} </span></div>);
  }

  private renderAssignedUserTaskLink() {
    if (!this.props.roles.includes(Role.AsUs)) { return; }
    return (
      <div className={this.props.caseSearch.hasUnassignedUser ? [styles.taskFilterLinkWithMargin, styles.bold].join(' ') : styles.taskFilterLinkWithMargin }>
        <span onClick={() => {this.searchCasesByFilterBar(CaseSearchParam.HasUnassignedUser); }}>{this.localization.get('header.assignedUserTasks')}</span><span>: {this.props.countOfUnassigned}</span></div>);
  }

  private renderTotalVsArchivedTaskCount() {
    const totalCount = this.props.countOfArchived + this.props.countOfOpened;
    return (<div className={styles.taskFilterLink}>
      <span>{this.localization.get('header.active')}</span><span>: {this.props.countOfOpened} </span>
      <span>{this.localization.get('header.archived')}</span><span>: {this.props.countOfArchived}|</span>
      <span>{this.localization.get('header.total')}</span><span>: {totalCount}</span>
      </div>);
  }


  private getTaskLinkDivVisibility() {
    const style: any = { visibility: 'visible' };

    return style;
  }
  searchCasesByFilterBar = (param: number) => {
    const caseSearch = {
      ...this.props.caseSearch,
      caseCode: '',
      archived: false,
      agendaRef: '',
      policyHolder: '',
      taskType: '',
      hasDocumentForApproval: param === CaseSearchParam.HasDocumentForApproval ? !this.props.caseSearch.hasDocumentForApproval : false,
      hasUnassignedUser: param === CaseSearchParam.HasUnassignedUser ? !this.props.caseSearch.hasUnassignedUser : false,
      hasMissingHonoraryNote: param === CaseSearchParam.HasHonoraryNoteMissing ? !this.props.caseSearch.hasMissingHonoraryNote : false,
      sortColumn: 'START_DATE' as CaseSortColumnType,
      sortDirection: 'DESC' as SortColumnDirectionType,
      selectedPartyId: 0,
      assignedToPartyId: 0,
      childParties: [],
      selectedChildPartyId: 0,
      inProgressOnly: false,
    };
  
    this.props.clearCases();
    this.props.fetchCases(caseSearch, 0, false);
  };
  


  getInsuranceLogoIcon() {
    switch (this.props.policySubTypeTC) {
      case PolicySubTypeTCEnum.BELFIUS_HOME:
        return <img src={require('../../assets/images/belfius_logo_218x46.png')} className={styles.policyTypeIcon} alt="" />;
      case PolicySubTypeTCEnum.DVV_BRAND:
        if (this.props.insuredPerson.languageTC === 'nl-BE') {
          return <img src={require('../../assets/images/dvv_nl.png')} className={styles.policyTypeIcon} alt="" />;
        } else {
          return <img src={require('../../assets/images/dvv_fr.png')} className={styles.policyTypeIcon} alt="" />;
        }
      default:
        return '';
    }
  }

  private getCenterInfo() {
    const pathname = window.location.pathname;

    if (pathname === '/') {
      return <div className={styles.taskFilterDivContainer}>
        <div className={styles.taskFilterDiv} style={this.getTaskLinkDivVisibility()}>
          {this.renderHonoraryNoteTaskLink()}
          {this.renderAssignedUserTaskLink()}
          {this.renderDocumentsForApprovalCount()}
          {this.renderTotalVsArchivedTaskCount()}
        </div>
      </div>;
    } else if (pathname.startsWith('/details') && this.props.insuredPerson) {
      const fullName = `${this.props.insuredPerson.firstName} ${this.props.insuredPerson.lastName},`;
      let insuredRiskData = ` ${this.props.insuredRisk.city !== undefined ? this.props.insuredRisk.city : '' }, ${this.props.insuredRisk.street !== undefined ? this.props.insuredRisk.street : ''} ${this.props.insuredRisk.buildingNumber !== undefined ? this.props.insuredRisk.buildingNumber : ''}`;

      const busNumber = `${this.props.insuredRisk.boxNumber !== undefined ? this.props.insuredRisk.boxNumber : ''}`;
      let phone = `${this.props.insuredPerson.telephone}`;
      let mobile = `${this.props.insuredPerson.mobile}`;
      if (busNumber !== `null` && busNumber !== `?` && busNumber !== `undefined`) {
        insuredRiskData += ` ` + busNumber;
      }
      if (mobile !== `null` && mobile !== `?` && mobile !== `undefined`) {
        mobile = mobile.replace(' ', '/');
        insuredRiskData += `, ` + mobile.replace(/[/]+/g, '/').replace(/\s/g, '');
      } else if (phone !== `null` && phone !== `?` && phone !== `undefined`) {
        phone = phone.replace(' ', '/');
        insuredRiskData += `, ` + phone.replace(/[/]+/g, '/').replace(/\s/g, '');
      }

      return (
        <div className={styles.currentCaseContainer}>
          <div className={styles.damageType}>
            <div>
              {this.props.damageIcon !== '' ? <img src={require('../../assets/images/' + this.props.damageIcon + '_75x75.png')} className={styles.damageTypeIcon} alt="" /> : ''}
            </div>
            <div className={styles.insuranceLogo}>
              {this.getInsuranceLogoIcon()}
            </div>
          </div>
          <div>
            <BelfiusText><strong>{this.props.caseCode}</strong> {fullName} {insuredRiskData}</BelfiusText><br></br>
            <BelfiusText>{this.props.expertName}</BelfiusText>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    const actionButton = this.getActionButton();
    const assignUserButton = this.getAssignUserButton();
    const archiveCaseButton = this.getArchiveCaseButton();
    const centerInfo = this.getCenterInfo();

    return (
      <div className={styles.container}>
        <Link
          className={styles.logo}
          to='/'
          onClick={() => {
            this.props.resetDetailsState();
            const pageRequest = new SharedActionPage();
            pageRequest.instructionId = this.instructionId;
            pageRequest.previousPage = this.props.currentPage;
            pageRequest.page = DetailsSharedActionPage.INSURED_PERSON;
            this.props.changePage(pageRequest);
          }}
        >
          <BelfiusTooltip title={this.localization.get('home.logo.tooltip')}>
            <img src={require('../../assets/images/prodatex_home.png')} alt="" />
          </BelfiusTooltip>
        </Link>
        {centerInfo}
        <span className={styles.spacer} />
        {archiveCaseButton}
        {assignUserButton}
        {actionButton}
      </div>
    );
  }
}

const mapStateToProps = ({ caseState, details, shared }: ApplicationState) => ({
  searchBarVisible: caseState.searchBarVisible,
  currentPage: details.detailsShared.currentPage,
  insuredPerson: details.detailsInsuredPerson,
  insuredRisk: details.detailsPolicy.insuredRisk,
  countOfOpened: caseState.caseCount.countOfOpened,
  countOfArchived: caseState.caseCount.countOfArchived,
  countOfHasDocForApproval: caseState.caseCount.countOfHasDocForApproval,
  countOfHonoraryNoteMissing: caseState.caseCount.countOfHonoraryNoteMissing,
  countOfUnassigned: caseState.caseCount.countOfUnassigned,
  roles: shared.roles,
  caseSearch: caseState.caseSearch,
  damageIcon: caseState.selectedCase.damageIcon,
  policySubTypeTC: caseState.selectedCase.policySubTypeTC,
  caseBlocked: caseState.selectedCase.blocked,
  caseCode: caseState.selectedCase.caseCode,
  expertName: caseState.selectedCase.expertName,
  hasDocumentsForApproval: caseState.hasDocumentsForApproval,
  selectedCase: caseState.selectedCase,
  showArchiveModal: caseState.archiveModalVisible,
  showAssignModal: caseState.showAssignModal,
  assignableUsers: caseState.assignableUsers,
  selectedAssignedUserId: caseState.selectedAssignedUserId,
  selectedClaimNotificationId: caseState.selectedClaimNotificationId,
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  showSearchBar: () => dispatch(showSearchBar()),
  changePage: (pages: Partial<SharedActionPage>) => dispatch(changePage({ ...pages })),
  resetDetailsState: () => {
    dispatch(resetSelectedPage());
    dispatch(resetDetailsCaseState());
    dispatch(resetDetailsPolicyState());
    dispatch(resetDetailsInsuredPersonState());
    dispatch(resetDetailsExpertiseAttachmentState());
    dispatch(resetDetailsImagesState());
    dispatch(resetDetailsOtherAttachmentsState());
    dispatch(resetSvsState());
    dispatch(resetDetailsRimState());
    dispatch(resetCasesState());
    dispatch(resetDetailsHonoraryNoteState());
  },
  logout: () => dispatch(logout()),
  fetchCases: (caseSearch: CaseSearch, offset: number, searchClicked) => dispatch(fetchCases(caseSearch, offset, searchClicked)),
  clearCases: () => dispatch(clearCases()),
  archiveCase: (selectedCase: CaseResponse) => dispatch(archiveCase(selectedCase)),
  archiveCaseOpen: (selectedCase: CaseResponse) => dispatch(archiveCaseOpen(selectedCase)),
  dearchiveCase: (selectedCase: CaseResponse) => dispatch(dearchiveCase(selectedCase)),
  archiveCaseClose: () => dispatch(archiveCaseClose()),
  assignUserOpen: (claimNotificationId: number) => dispatch(assignUserOpen(claimNotificationId)),
  assignUserClose: () => dispatch(assignUserClose()),
  changeAssignedUserId: (userId: number) => dispatch(changeAssignedUserId(userId)),
  assignUser: (userId: number, claimNotificationId: number, expertName: string) => dispatch(assignUser(userId, claimNotificationId, expertName)),
  setInProgressState: (selectedCase: CaseResponse) => dispatch(setInProgressState(selectedCase)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withParams(Header));
